import { FC, PropsWithChildren } from "react";

import { type LinkWrapperProps } from "@jti/ui/providers/LinkBehaviourContext";

import { Link } from "@/libs/i18n";

export const NextLinkWrapper: FC<PropsWithChildren<LinkWrapperProps>> = ({
  children,
  href,
  ...props
}) => {
  if (!href) {
    console.error("href is required for link");
    return <a {...props}>{children}</a>;
  }
  return (
    <Link
      href={href}
      onNavigate={(e) => {
        // This is a workaround for the issue with Next.js, Cloudflare Worker and anchor links for coexisting pages.
        // When the link contains a hash (#) and redirects to another page, it should not be handled by Next.js, but rather by the browser.
        // https://jira.jtiweb.co.uk/browse/DESP-94243 - example of the issue.
        // TODO: remove this workaround when there will be only Builder.
        const url = new URL(href, window.location.origin);

        if (
          url.origin === window.location.origin &&
          url.pathname !== window.location.pathname &&
          url.hash
        ) {
          window.location.href = href;
          e.preventDefault();
        }
      }}
      {...props}
    >
      {children}
    </Link>
  );
};
